import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { SelectItem } from '@core/models/select-item.model';

import * as fromRulesModel from  '@app/models/rules';

@Component({
  selector: 'settings-rules-rule-form-actions-item',
  templateUrl: './actions-item.component.html',
  styleUrls: ['./actions-item.component.scss'],
})
export class SettingsRulesRuleFormActionsItemComponent implements OnInit, OnChanges {
    public readonly STATUS_LOADING = 0;
	public readonly STATUS_DONE = 1;

    @Input() availableActions: Array<fromRulesModel.AvailableRuleEventAction> = [];
    @Input() actionForm: fromRulesModel.AvailableRuleItemForm; //RuleAction;
    @Input() ruleActions: Array<fromRulesModel.RuleAction>;
    @Output() clickAdd = new EventEmitter();
    @Output() clickRemove = new EventEmitter<string>();
    // @Output() selectAction = new EventEmitter<RuleAction>();
    @Output() selectAction = new EventEmitter();
    @Output() variablesChange = new EventEmitter<fromRulesModel.RuleActionParameters>();

    public status: number = this.STATUS_LOADING;
    public actions: Array<SelectItem> = []; // actions loaded: do not change until event change
    public actionVariables: Array<any> = []; // varaibles of action loaded: do not change until action change
    public availableActionVariables: Array<fromRulesModel.AvailableRuleActionVariable> = [];

    public currentAction: fromRulesModel.AvailableRuleEventAction = null;
    public currentRuleAction: fromRulesModel.RuleAction = null;
    // public term: string = '';

    constructor(){}

    ngOnInit(){
        if(this.actionForm != null && this.availableActions != null){ 
            this.currentAction = this.getAction(this.actionForm.key);
            this.currentRuleAction = this.getRuleAction(this.actionForm.id);
        }

        this.init();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.ruleActions){
            this.currentRuleAction = this.getRuleAction(this.actionForm.id);
        }
        if(changes.availableActions){
            this.init();
        }
    }

    init(){
        this.availableActionVariables = this.getAvalaibleActionVariables();

    }

    getCurrentActionVariable(key: string) {
        if(this.availableActionVariables.length == 0){
            return {key: "", value: ""};
        }
        let av: Array<fromRulesModel.AvailableRuleActionVariable> = this.availableActionVariables.filter((v: fromRulesModel.AvailableRuleActionVariable) => v.key == key);
        if(av.length == 0)
            return {key: "", value: ""};

        let firstValue = av[0].values.length > 0 ? av[0].values[0].key : null;

        // find into values the default value if exist to set it
        if(av[0].default !== null && av[0].values.length) {
            let dval = av[0].values.filter((v:{key: string}) => v.key == av[0].default);

            firstValue = dval.length>0? dval[0].key : firstValue;
        }
        
        // when parameters set in the rule editing are not all there like we MUST not set a value
        // Get the keys of the parameters in editing / loaded current rule
        const parameterKeys = Object.keys(this.currentRuleAction.parameters);

        // Check if all keys from availableKeys are present in parameterKeys
        const allKeysPresent = this.availableActionVariables.every((item) => parameterKeys.includes(item.key));
        // DEBUG: Find the keys that are present in availableKeys but not in current parameterKeys
        // const unmatchedKeys = this.availableActionVariables.filter((item) => !parameterKeys.includes(item.key));
        if (!allKeysPresent) {
            firstValue = "";  // we set as empty the value for current key, all the keys will set 
            // console.log("Some keys from availableKeys are not present in parameterKeys.");
            // console.log("The keys not present in parameterKeys.", unmatchedKeys);
        }
        // despite the previous check if current rule has a parameter set, we keep it
        return {
            key: key,
            value: this.currentRuleAction.parameters.hasOwnProperty(key) ? this.currentRuleAction.parameters[key] : firstValue
        };
    }

    onSelectAction(e){
        this.selectAction.emit(e.key);
    }

    addAction() {
        this.clickAdd.emit();
    }

    removeAction() {
        this.clickRemove.emit(this.actionForm.id);
    }

    getAvalaibleActionVariables() : Array<fromRulesModel.AvailableRuleActionVariable> {
        let actionIndex = this.availableActions.findIndex((a: fromRulesModel.AvailableRuleEventAction) => a.key == this.actionForm.key);
        if(actionIndex != -1 )
            return this.availableActions[actionIndex].variables;
        
        return [];
    }

    selectVariable(variablesSelected ) {
        // ng14 we cannot modify properties directly, because they could be readonly
        let actionParam = {...this.currentRuleAction.parameters};
        actionParam[variablesSelected.key] = variablesSelected.value;

        this.variablesChange.emit(actionParam);
    }

    getAction(key: string) : fromRulesModel.AvailableRuleEventAction {
        let as = this.availableActions.filter((aa:fromRulesModel.AvailableRuleEventAction) => aa.key == key );

        return as[0];
    }

    // filter the action for the current rule by given form id
    getRuleAction(id: string) : fromRulesModel.RuleAction {
        let ca = this.ruleActions.filter((aa:fromRulesModel.RuleAction) => aa.form_id == id );
        return ca[0];
    }



}
